/**
 * @module app.bdc.common.indexCtrl
 *
 * The var names witch contain "loading" mean : is a request pending ?
 */
define(['angular'], function(angular) {

    function IndexCtrl(
        $scope,
        $window,
        $location,
        $cookies,
        $log,
        $rootScope,
        Notification,
        clientService,
        orderService,
        orderFormService,
        userNetworkService,
        walletService,
        storeService,
        userService
    ) {
        let self = {};
        // Nav menu
        // client, bdc, wallet, relance, kya, document, dashboard, devance
        $scope.navMenu = [
            { id: '1', label: 'Accueil', mobile: 'Accueil', selected: true, url: '/portal', svg: 'House1', class: '', portal: false, right: ['user', 'userDevance', 'admin']},
            { id: '2', label: 'Base Prospects & Clients', mobile: 'KYC', selected: false, url: '/prospection/search/', svg: 'CardPin', class: 'card-kyc', portal: true, right: ['user', 'userDevance', 'admin']},
            { id: '3', label: 'Bons de Commande', mobile: 'BDC', selected: false, url: '/bdc/list/', svg: 'CheckList', class: 'card-bdc', portal: true, right: ['user', 'admin'] },
            { id: '6', label: "Affaires & devis", mobile: 'PA', selected: false, url: '/prospection/wallet/', svg: 'Wallet', class: 'card-wallet', portal: true, right: ['user', 'admin'] },
            { id: '9', label: 'Gestion des relances', selected: false, mobile: 'RDV', url: '/prospection/reminder/', svg: 'Phone', class: 'card-reminder', portal: true, right: ['user', 'admin'] },
            { id: '4', label: 'Contrats de Services (KYA)', mobile: 'KYA', selected: false, url: '/kya/list/', svg: 'User1', class: 'card-kya', portal: true, right: ['user', 'admin'] },
            { id: '5', label: 'Documents', selected: false, mobile: 'Doc', url: '/bdc/files/', svg: 'OfficeFilePdf1', class: 'card-document', portal: true, right: ['user', 'admin'] },
            { id: '7', label: 'Dashboard', selected: false, mobile: 'TDB', url: '/dashboard/', svg: 'Dashboard', class: 'card-dashboard', portal: true, right: ['user', 'admin'] },
            {
                id: '8',
                label: 'Devance',
                selected: false,
                mobile: 'DEV',
                url: null,
                svg: 'Devance',
                class: 'card-devance',
                portal: true,
                right: ['devance', 'admin', 'userDevance'],
                subMenu: [
                    {id: '8.1', label: 'Mouvements de parc', selected: false, url: '/devance/pos-movements/', svg: 'RatingStar1'},
                    {id: '8.2', label: 'Mouvements services', selected: false, url: '/devance/services-movements/', svg: 'RatingStar1'}
                ]
            },

            {
                id: '99',
                label: 'Administration',
                selected: false,
                mobile: 'Admin',
                url: null,
                svg: 'Cog',
                class: '',
                portal: false,
                right: ['admin'],
                subMenu: [
                    {id: '99.1', label: 'Import ranking TA', selected: false, url: '/administration/ranking-ta', svg: 'RatingStar1'},
                    {id: '99.2', label: 'Utilisateurs', selected: false, url: '/administration/users', svg: 'RatingStar1'},
                    {id: '99.3', label: 'Sectorisation', selected: false, url: '/administration/sectors', svg: 'RatingStar1'}
                ]
            },
            { id: '10', label: 'Problèmes GLPI', selected: false, mobile: 'GLPI', url: '/glpi-problems/', svg: 'Glpi', class: 'card-glpi', portal: true, right: ['user', 'admin'] },
        ];

        self.displayMenu = (menu) => {
            if(!$rootScope.user) return false;
            return Object.keys($rootScope.user.rights).some(key =>
                $rootScope.user.rights[key] && menu.right.includes(key)
            );
        }

        $scope.loadingScreen = true;

        $scope.goBack = function() {
            $window.history.back();
        };
        $scope.goTo = function() {
            let path = Array.prototype.slice.call(arguments).join('/');
            $scope.displayMenu = false;
            $location.path(path);
        };

        $scope.open = (menu) => {
            const isString = typeof menu === 'string';
            menu = isString ? $scope.navMenu.find(m => m.label === menu) : menu;
            let masterMenu = menu.id.split('.');
            $scope.navMenu.map(m => {
                if(masterMenu.length > 1) {
                    m.selected = m.id === masterMenu[0];
                    if(m.subMenu) {
                        if (isString) {
                            m.subMenu[0].selected = true;
                        }
                        else {
                            m.subMenu.map(s => {
                                s.selected = s.id === menu.id
                            });
                        }
                    }
                }else {
                    if(m.id === menu.id){
                        m.selected = !m.selected;
                    }else{
                        m.selected = false;
                    }
                }
            });

            const url = isString ? menu.subMenu ? menu.subMenu[0].url: menu.url : menu.url;
            if(!url) return;
            $scope.goTo(url);
        }

        $scope.displayMenu = false;

        $scope.message = null;

        self.accessToken = $cookies.get('accessToken') ? $cookies.get('accessToken') : null;
        //self.user = $cookies.getObject('user') ? $cookies.getObject('user') : null;

        // $cookies.remove('user', { path: $rootScope.mode === 'dev' ? '/' : '/bdc' });
        if (self.accessToken) {
            $rootScope.isLogin = true;
            $rootScope.accessToken = self.accessToken;
        }
        else {
            $rootScope.isLogin = false;
        }

        self.toggleDisplay = () => {
            $scope.displayMenu = !$scope.displayMenu;
        }



        // Network status
        $scope.$root.online = navigator.onLine;

        $window.addEventListener(
            'offline',
            function() {
                $scope.$apply(function() {
                    $scope.$root.online = false;
                    $scope.$root.$broadcast('offline');
                    $log.info('Offline');
                });
            },
            false
        );

        $window.addEventListener(
            'online',
            function() {
                $scope.$apply(function() {
                    $scope.$root.online = true;
                    $scope.$root.$broadcast('online');
                    $log.info('Online');
                });
            },
            false
        );

        if ($window.applicationCache) {
            $window.applicationCache.addEventListener('updateready', function(params) {
                $log.info('nouvelle version disponible', params);
                $scope.message = {
                    message: "Une nouvelle version de l'application est disponible. Rechargez pour mettre à jour.",
                    type: 'info'
                };
                $window.applicationCache.swapCache();
            });
        }

        $scope.$root.$on('$routeChangeStart', function() {
            $scope.loadingScreen = true;
        });

        $scope.$root.$on('$routeChangeSuccess', function() {
            if(!self.loading) {
                $scope.loadingScreen = false;
            }
        });

        self.clearCache = function clearCache(isLogout, isHelpline) {
            isLogout = isLogout === undefined ? false : isLogout;
            isHelpline = isHelpline === undefined ? false :isHelpline;
            clientService.clearCache().then(function() {
                orderService.clearCache().then(function() {
                    walletService.clearCache().then(function() {
                        storeService.clearCache().then(function() {
                            orderFormService.clearCache();
                            userNetworkService.clearCache();
                            if(isLogout){
                                if(!isHelpline)
                                    $location.path('login');
                            }else{
                                location.reload(true);
                            }

                        });
                    });
                });
            });
        };

        self.logOut = function() {
            let path = $rootScope.mode === 'dev' ? '/' : '/bdc';
            $cookies.remove('user', { path: path });
            $cookies.remove('accessToken', { path: path });
            // document.location.href = window.location.origin + window.location.pathname;
            $rootScope.isLogin = false;
            if ($rootScope.user.isHelpline){
                self.clearCache(true, true);
                userService.logOutHelpline();
            }else {
                self.clearCache(true);
            }
            self.toggleDisplay();
        };

        $scope.$on('synchro-off', function() {
            Notification('La synchronisation est terminée');
        });

        function _init(){
            self.loading = true;
            $scope.loadingScreen = true;
            userService.initUserNetWork()
                .then(()=>{
                    self.loading = false;
                    $log.info('User', $rootScope.user);
                    // $rootScope.isDevanceAccess = ['RESP TELEPRO', 'TELEPRO', 'DC', 'SUPPORT CO'].includes($rootScope.user.role);
                    $rootScope.isDevanceAccess = $rootScope.user.rights.devance;
                    $rootScope.isUserDevance = $rootScope.user.rights.isUserDevance;
                })
                .catch(err => {
                    Notification.error(err.data)
                }).finally(()=>{
                $scope.loadingScreen = false;
                $scope.navMenu.map(menu => {
                    menu.selected = menu.url ? menu.url === $location.path() : false;
                    if(menu.subMenu) {
                        menu.subMenu.map(subMenu => {
                            subMenu.selected = subMenu.url ? subMenu.url === $location.path() : false;
                            if(subMenu.selected){
                                menu.selected = true;
                            }
                        });
                    }
                });
                if($location.path().indexOf('/prospection/store') > -1){
                    $scope.navMenu.find(m => m.label === 'Base Prospects & Clients').selected = true;
                }
            });
        }
        if($rootScope.isLogin){
            _init();
        }

        return self;
    }

    IndexCtrl.$inject = [
        '$scope',
        '$window',
        '$location',
        '$cookies',
        '$log',
        '$rootScope',
        'Notification',
        'clientService',
        'orderService',
        'orderFormService',
        'userNetworkService',
        'walletService',
        'storeService',
        'userService'
    ];

    angular
        .module('app.bdc.common.indexCtrl', [])
        .controller('IndexCtrl', IndexCtrl)
        .config([
            'NotificationProvider',
            function(NotificationProvider) {
                NotificationProvider.setOptions({
                    delay: 5000,
                    startTop: 60,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'center',
                    positionY: 'top'
                });
            }
        ]);
});
